// extracted by mini-css-extract-plugin
export default {"block":"item__block___yjy43","wrapper":"item__wrapper___Wzj7q","quantity":"item__quantity___WB77v","budge":"item__budge___rkHsQ","icon":"item__icon___CvCnv"};